<template>
  <div>
    <div class="pag-wrap" v-if="showPage">
      <my-header
          main-title="发票业务"
          v-bind="$attrs"
          @back="emit('changePage', 'package')"
          @changePage="val => emit('changePage', val)"
      />

      <div class="content-box">
        <el-card>
          <template #header>
            <div class="card-header">
              <h3>开票业务办理</h3>
              <span class="sub-bt">发件邮箱设置</span>
            </div>
          </template>

          <div style="display: flex;align-items: center;">
            <div class="business-item"
                 v-for="(item,idx) in digOptions"
                 :key="idx"
                 @click="goForWardPage(item)"
            >
              <img
                  :src="item.iconPath"
                  alt="">
              <span>{{ item.label }}</span>
            </div>
          </div>
        </el-card>

        <el-card style="margin-top: 20px;">
          <template #header>
            <div class="card-header">
              <h3>开票情况概览</h3>
              <span class="sub">当前月份：{{ currentMonth }}</span>
            </div>
          </template>

          <div class="left-row-content">
            <div class="row-item">
              可用发票额度（元）
              <div class="big red">
                {{ usageStatist.remainAmount }}
                <el-button
                    size="small"
                    type="primary"
                    @click="goAdjust"
                    plain>去调整
                </el-button>
              </div>

              <div class="bot-item">发票总额度： {{ usageStatist.totalCreditLimit }}元</div>
              <div class="bot-item">-</div>
            </div>

            <div class="sep"></div>
            <div class="row-item">
              当前可用纸票数量（张）
              <div class="big">0</div>

              <div class="bot-item">已开具： 0张</div>
              <div class="bot-item">-</div>
            </div>

            <div class="sep"></div>
            <div class="row-item">
              蓝字发票开具金额（元）
              <div class="big">{{ usageStatist.blueAmount }}</div>

              <div class="bot-item">蓝字发票累计税额：{{ usageStatist.blueTax }}元</div>
              <div class="bot-item">蓝字发票数量： {{ usageStatist.blueCount }}张</div>
            </div>

            <div class="sep"></div>
            <div class="row-item">
              红字发票开具金额（元）
              <div class="big">{{ usageStatist.redAmount }}</div>

              <div class="bot-item">红字发票累计税额：{{ usageStatist.redTax }}元</div>
              <div class="bot-item">红字发票数量：{{ usageStatist.redCount }}张</div>
            </div>
          </div>
        </el-card>

        <el-card style="margin-top: 20px;">
          <template #header>
            <div class="card-header">
              <h3>用票业务办理</h3>
            </div>
          </template>

          <div style="display: flex;align-items: center;">
            <div class="business-item" @click="goQueryStatist">
              <img
                  src="data:image/svg+xml;base64,PHN2ZyBpZD0i5Y+R56Wo5p+l6K+i57uf6K6hIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NiIgaGVpZ2h0PSI1NiIgdmlld0JveD0iMCAwIDU2IDU2Ij4KICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzI5NiIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMjk2IiB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIGZpbGw9IiNjNGM0YzQiIG9wYWNpdHk9IjAiLz4KICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzI5NyIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMjk3IiB3aWR0aD0iNDYiIGhlaWdodD0iNDYiIHJ4PSI0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1IDUpIiBmaWxsPSIjNTU5MGU4Ii8+CiAgPGcgaWQ9Iue7hF8xNCIgZGF0YS1uYW1lPSLnu4QgMTQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4Ni4yNDggLTEwMy44NDQpIj4KICAgIDxwYXRoIGlkPSLot6/lvoRfMyIgZGF0YS1uYW1lPSLot6/lvoQgMyIgZD0iTS0xNjMuMzEsMTQyLjM0NGgtNC45Mzh2LTIyLjVoMTcuMjczdjUiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjMiLz4KICAgIDxnIGlkPSLmpK3lnIZfMiIgZGF0YS1uYW1lPSLmpK3lnIYgMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE2NC4yNDggMTI2Ljg0NCkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIzIj4KICAgICAgPGNpcmNsZSBjeD0iNi41IiBjeT0iNi41IiByPSI2LjUiIHN0cm9rZT0ibm9uZSIvPgogICAgICA8Y2lyY2xlIGN4PSI2LjUiIGN5PSI2LjUiIHI9IjUiIGZpbGw9Im5vbmUiLz4KICAgIDwvZz4KICAgIDxsaW5lIGlkPSLnm7Tnur9fMTIiIGRhdGEtbmFtZT0i55u057q/IDEyIiB4Mj0iMy4zMTYiIHkyPSIzLjMxNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE1MS41MzYgMTQwLjEwOSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjMiLz4KICA8L2c+Cjwvc3ZnPgo="
                  alt="">
              <span>发票查询统计</span>
            </div>

            <div class="business-item">
              <img
                  src="data:image/svg+xml;base64,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"
                  alt="">
              <span>发票查验</span>
            </div>
            <div class="business-item">
              <img
                  src="data:image/svg+xml;base64,PHN2ZyBpZD0i5raJ56iO5L+h5oGv5p+l6K+iIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NiIgaGVpZ2h0PSI1NiIgdmlld0JveD0iMCAwIDU2IDU2Ij4KICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzMwNyIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMzA3IiB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIGZpbGw9IiNjNGM0YzQiIG9wYWNpdHk9IjAiLz4KICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzMwOCIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMzA4IiB3aWR0aD0iNDYiIGhlaWdodD0iNDYiIHJ4PSI0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1IDUpIiBmaWxsPSIjZjE3YzM4Ii8+CiAgPGcgaWQ9Iue7hF8zMyIgZGF0YS1uYW1lPSLnu4QgMzMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1NzAgMjk3LjI1KSI+CiAgICA8cGF0aCBpZD0i6Lev5b6EXzU0IiBkYXRhLW5hbWU9Iui3r+W+hCA1NCIgZD0iTTE2Mi4wNjMsMjQxLjYyNXYtNC4xNDZsLTEyLjUsMi0xMi41LTJ2MTZsMTIuNSwyLDEuNjItLjI1OSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE2OTMuMDYzIC01MTUuNDc5KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMyIvPgogICAgPGcgaWQ9Iue7hF8zMiIgZGF0YS1uYW1lPSLnu4QgMzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xIC0xKSI+CiAgICAgIDxnIGlkPSLmpK3lnIZfMTMiIGRhdGEtbmFtZT0i5qSt5ZyGIDEzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTU0MCAtMjcxKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjMiPgogICAgICAgIDxjaXJjbGUgY3g9IjciIGN5PSI3IiByPSI3IiBzdHJva2U9Im5vbmUiLz4KICAgICAgICA8Y2lyY2xlIGN4PSI3IiBjeT0iNyIgcj0iNS41IiBmaWxsPSJub25lIi8+CiAgICAgIDwvZz4KICAgICAgPGxpbmUgaWQ9IuebtOe6v180MCIgZGF0YS1uYW1lPSLnm7Tnur8gNDAiIHgyPSIyIiB5Mj0iMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE1MjcuNSAtMjU4LjUpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIzIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"
                  alt="">
              <span>涉税信息查询</span>
            </div>
            <div class="business-item">
              <img
                  src="data:image/svg+xml;base64,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"
                  alt="">
              <span>海关缴款书采集</span>
            </div>
            <div class="business-item">
              <img
                  src="data:image/svg+xml;base64,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"
                  alt="">
              <span>发票入账标识</span>
            </div>
            <div class="business-item">
              <img
                  src="data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NiA1NiIgY2xhc3M9ImRlc2lnbi1pY29uZm9udCI+CiAgPHBhdGggZD0iTTQ3IDVIOUM2Ljc5MDg2IDUgNSA2Ljc5MDg2IDUgOVY0N0M1IDQ5LjIwOTEgNi43OTA4NiA1MSA5IDUxSDQ3QzQ5LjIwOTEgNTEgNTEgNDkuMjA5MSA1MSA0N1Y5QzUxIDYuNzkwODYgNDkuMjA5MSA1IDQ3IDVaIiBmaWxsPSIjNTU5MEU4Ii8+CiAgPHBhdGggZD0iTTI2LjY4MyAyNC4zNDc2TDE2IDE1SDQwTDI5LjMxNyAyNC4zNDc2QzI4LjU2MyAyNS4wMDc0IDI3LjQzNyAyNS4wMDc0IDI2LjY4MyAyNC4zNDc2WiIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjMiLz4KICA8cGF0aCBkPSJNMTUgMTZWMjEuMTk0NUMxNi42MDYgMjIuMjAxOCAxNy42NzcgMjMuOTg3OSAxNy42NzcgMjYuMDE1QzE3LjY3NyAyOC4wNDI0IDE2LjYwNiAyOS44Mjg5IDE1IDMwLjgzNjNWMzYuMDNINDFWMzAuODM2M0MzOS4zOTQgMjkuODI4OSAzOC4zMjMgMjguMDQyNCAzOC4zMjMgMjYuMDE1QzM4LjMyMyAyNC40OTkyIDM4LjkxMjIgMjMuMDczNSAzOS45ODIyIDIyLjAwMDVDNDAuMjkzNiAyMS42ODgzIDQwLjYzNSAyMS40MTY2IDQxIDIxLjE4ODJWMTZIMTVaTTEyIDEzSDQ0VjIzLjMyOUM0Mi41MiAyMy4zMzUgNDEuMzIzIDI0LjUzNCA0MS4zMjMgMjYuMDE1QzQxLjMyMyAyNy40OTYgNDIuNTIgMjguNjk2IDQ0IDI4LjcwMlYzOS4wM0gxMlYyOC43MDJDMTMuNDc5IDI4LjY5NiAxNC42NzcgMjcuNDk2IDE0LjY3NyAyNi4wMTVDMTQuNjc3IDI0LjUzNCAxMy40NzkgMjMuMzM1IDEyIDIzLjMyOVYxM1oiIGZpbGw9IiNmZmYiLz4KPC9zdmc+Cg=="
                  alt="">
              <span>收票箱</span>
            </div>
            <div class="business-item">
              <img
                  src="data:image/svg+xml;base64,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"
                  alt="">
              <span>助信码</span>
            </div>
          </div>
        </el-card>

        <div style="display: flex;margin-top: 20px;">
          <el-card style="width: 0;flex-grow: 1;">
            <template #header>
              <div class="card-header">
                <h3>风险提示</h3>
              </div>
            </template>

            <div class="left-right-content">
              <div class="left">
                取得异常凭证数量（张）
                <div class="big">
                  0
                  <el-button
                      size="small"
                      type="primary"
                      plain>去查看
                  </el-button>
                </div>

                <div class="bot-item">-</div>
                <div class="bot-item">-</div>
              </div>
              <div class="sep"></div>
              <div class="right">
                取得异常凭证金额合计（元）
                <div class="big">0.00</div>

                <div class="bot-item">异常凭证税额：0.00元</div>
                <div class="bot-item">-</div>
              </div>
            </div>
          </el-card>

          <el-card style="width: 0;flex-grow: 1;margin-left: 20px;">
            <template #header>
              <div class="card-header">
                <h3>受票情况</h3>
                <div class="grow"></div>
                <el-link
                    :underline="false"
                    type="primary">查看详情>
                </el-link>

              </div>
            </template>

            <div class="left-right-content">
              <div class="left">
                取得蓝字发票数量（张）
                <div class="big">{{ pageShowVal.noTaxAmountTotal || 0 }}</div>

                <div class="bot-item">发票金额：{{ pageShowVal.tickAmount || '0.00' }}元</div>
                <div class="bot-item">发票税额：{{ pageShowVal.tickTax || '0.00' }}元</div>
              </div>
              <div class="sep"></div>
              <div class="right">
                取得红字发票数量（张）
                <div class="big">{{ pageShowVal.alreadyConfirmTax || 0 }}</div>

                <div class="bot-item">红冲金额：{{ pageShowVal.taxAmountTotal || '0.00' }}元</div>
                <div class="bot-item">红冲税额：{{ pageShowVal.fs || '0.00' }}元</div>
              </div>
            </div>

          </el-card>
        </div>

        <footer style="display: flex;justify-content: center;padding: 30px 0;opacity: 0.9;">
          <img src="https://static.rhkj.com/renhe_fe/other/333.png">
        </footer>
      </div>
    </div>
    <template v-else>
      <component :is="pageView" @go-invoice="showPage = true"/>
    </template>
  </div>
</template>

<script setup name="StateTax/invoice">
import {ElMessage, ElMessageBox} from 'element-plus';
import maintence from '../maintence/index';
import redInvoice from '../redInvoice/index';
import blueInvoice from '../blueInvoice/index';
import myHeader from "../cmp/myHeader.vue";
import adjustInvoiceLimit from '../adjustInvoiceLimit/index'
import dayjs from "dayjs";
import invoiceQueryStatist from '../invoiceQueryStatist'
import {useAllInvoice} from "@/views/digitalInvoice/invoiceQueryStatist/allInvoiceSummary.js";

const router = useRouter();

const {usageStatist} = useAllInvoice()

const showPage = ref(true);
const pageView = shallowRef();
//树数据
const digOptions = ref([
  {
    label: '开票信息维护',
    name: 'maintence',
    iconPath: 'https://static.rhkj.com/renhe_fe/other/351.svg'
  },
  {
    label: '蓝字发票开具',
    name: 'blueInvoice',
    iconPath: 'https://static.rhkj.com/renhe_fe/other/352.svg'
  },
  {
    label: '红字发票开具',
    name: 'redInvoice',
    iconPath: 'https://static.rhkj.com/renhe_fe/other/353.svg'
  },
  {
    label: '纸质发票业务',
    name: '',
    iconPath: 'https://static.rhkj.com/renhe_fe/other/354.svg',
  },
  {
    label: '发票额度调整申请',
    name: '',
    iconPath: 'https://static.rhkj.com/renhe_fe/other/355.svg',
  },
  {
    label: '开具原适用税率发票申请',
    name: '',
    iconPath: 'https://static.rhkj.com/renhe_fe/other/356.svg',
  },

]);

//跳转至下一页
function goForWardPage(data) {
  if (!data.name) {
    return ElMessageBox.confirm('该功能暂未开放，无需操作！！！', '信息', {
      showCancelButton: false,
      customStyle: {
        '--el-messagebox-width': '300px',
      },
    }).catch(() => {
    });
  }
  showPage.value = false;
  switch (data.name) {
    case 'blueInvoice':
      pageView.value = blueInvoice;
      break;
    case 'redInvoice':
      pageView.value = redInvoice;
      break;
    case 'maintence':
      pageView.value = maintence;
      break;
    case 'adjustInvoiceLimit':
      pageView.value = adjustInvoiceLimit;
      break
    case 'invoiceQueryStatist':
      pageView.value = invoiceQueryStatist
      break
  }
}

const pageShowVal = computed(() => {
  return {}
})

const currentMonth = computed(() => {
  return dayjs().format('YYYY年MM月')
})

const currentQa = inject('provideCurrentQa');

function goAdjust() {
  if (currentQa.value.sonQueType == '302') {
    goForWardPage({name: 'adjustInvoiceLimit'})
  } else {
    ElMessage({
      message: '当前题目业务模块非[申请调整发票额度]',
      type: 'warning',
      duration: 3500
    })
  }
}

function goQueryStatist() {
  if (currentQa.value.sonQueType != '301') {
    ElMessage({
      message: '当前题目业务模块非[发票查询统计]',
      type: 'warning',
      duration: 3500
    })
    return
  }
  goForWardPage({name: 'invoiceQueryStatist'})
}

const emit = defineEmits(['changePage']);
</script>

<style lang="scss" scoped>
.pag-wrap {
  .content-box {
    height: calc(100vh - 96px);
    background-color: #f2f2f2;
    box-sizing: border-box;
    padding: 20px 40px;
    overflow-y: auto;

    .card-header {
      display: flex;
      align-items: center;

      > h3 {
        font-size: 16px;
        font-weight: 700;
      }

      > span.sub {
        margin-left: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }

      > span.sub-bt {
        margin-left: 16px;
        font-size: 16px;
        font-weight: 500;
        color: #4285f4;
        cursor: pointer;
      }

      .grow {
        flex-grow: 1;
      }
    }

    .business-item {
      width: 138px;
      height: 139px;
      border: 1px solid #f2f2f2;
      display: flex;
      margin-right: 10px;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      flex-shrink: 0;

      > img {
        padding-top: 18px;
        display: block;
        width: 45px;
        height: 45px;
      }

      > span {
        width: 104px;
        margin-top: 20px;
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
      }
    }

    .left-right-content {
      display: flex;
      line-height: 30px;

      .left, .right {
        width: 0;
        flex-grow: 1;
      }

      .sep {
        width: 2px;
        background-color: #f2f2f2;
      }

      .right {
        padding-left: 20px;
      }

      .big {
        line-height: 40px;
        font-size: 28px;
        margin-bottom: 28px;
      }
    }

    .left-row-content {
      display: flex;
      line-height: 30px;

      .sep {
        margin-right: 20px;
        width: 1px;
        background-color: #f2f2f2;
      }

      .big {
        line-height: 40px;
        font-size: 28px;
        margin-bottom: 28px;

        &.red {
          color: rgb(252, 85, 65);
        }
      }

      .row-item {
        flex-grow: 1;
        width: 0;
      }
    }
  }
}
</style>
